import React, { useEffect, useState } from 'react';
import gpay from '../../../assets/images/common/icons/gpay.svg';
import paytm from '../../../assets/images/common/icons/paytm.svg';
import phonePe from '../../../assets/images/common/icons/phonepay.svg';
import bank from '../../../assets/images/common/icons/bank.svg';
import TabPanel from '../../../components/TabPanel/TabPanel';
import { Tabs, Tab, Button, TextField, Dialog } from '@material-ui/core';
import NumberFormat from 'react-number-format';
import Add from '@material-ui/icons/Add';
import { IonSpinner } from '@ionic/react';
import { DeleteForeverOutlined } from '@material-ui/icons';
import upiImg from '../../../assets/images/common/icons/UPI.svg';
import { AccountDetails } from '../AccountDetails';
import { fetchPaymentMethod } from './common';
import {
  AvailablePaymentGateways,
  AvailablePaymentMethods,
} from '../../../util/stringUtil';
import { PaymentMethodsInfo } from '../Deposit.types';

interface PgmanProps {
  tabValue: number;
  index: number;
  paymentOption: string;
  UpiOption: string;
  setPaymentOption: (paymentOption: string) => void;
  setUpiOption: (upiOption: string) => void;
  accountDetails: AccountDetails[];
  selectedAccountId: string;
  setSelectedAccountId: (id: string) => void;
  setShowDeleteModal: (status: boolean) => void;
  setDeleteId: (id: number) => void;
  setAddAccount: (status: boolean) => void;
  submitOnlinePayment: (event: React.FormEvent<HTMLFormElement>) => void;
  submitPayment: (event: React.FormEvent<HTMLFormElement>) => void;
  withdrawAmount: string;
  setWithdrawAmount: (amount: string) => void;
  loading: boolean;
  withdrawNotes: string;
  setWithdrawNotes: (notes: string) => void;
  addAccount: boolean;
  submitDetails: (event: React.FormEvent<HTMLFormElement>) => void;
  accountNumber: string;
  setAccountNumber: (accNum: string) => void;
  holderName: string;
  setHolderName: (name: string) => void;
  bankName: string;
  setBankName: (name: string) => void;
  setIfscCode: (code: string) => void;
  ifscCode: string;
  setBranchName: (name: string) => void;
  branchName: string;
  setDisplayName: (name: string) => void;
  displayName: string;
  setAccountDetails: (accounts: AccountDetails[]) => void;
  paymentMethodsInfo: PaymentMethodsInfo;
}

const Pgman: React.FC<PgmanProps> = ({
  index,
  paymentOption,
  setPaymentOption,
  setUpiOption,
  tabValue,
  UpiOption,
  accountDetails,
  selectedAccountId,
  setDeleteId,
  setSelectedAccountId,
  setShowDeleteModal,
  loading,
  setAddAccount,
  setWithdrawAmount,
  setWithdrawNotes,
  submitOnlinePayment,
  submitPayment,
  withdrawAmount,
  withdrawNotes,
  addAccount,
  accountNumber,
  setAccountNumber,
  submitDetails,
  bankName,
  branchName,
  holderName,
  ifscCode,
  setBankName,
  setBranchName,
  setHolderName,
  setIfscCode,
  displayName,
  setDisplayName,
  setAccountDetails,
  paymentMethodsInfo,
}) => {
  const [currentPaymentMethods, setCurrentPaymentMethods] = useState([]);

  useEffect(() => {
    if (paymentMethodsInfo.hasOwnProperty(AvailablePaymentGateways.PGMAN)) {
      const pgmanPaymentMethods =
        paymentMethodsInfo[AvailablePaymentGateways.PGMAN];
      setCurrentPaymentMethods(pgmanPaymentMethods);
    }
  }, [paymentMethodsInfo]);

  useEffect(() => {
    if (tabValue === index)
      fetchPaymentMethod(paymentOption, setAccountDetails);
  }, [tabValue]);

  const renderPaymentMethodTab = (paymentMethod: AvailablePaymentMethods) => {
    switch (paymentMethod) {
      case AvailablePaymentMethods.BANK_TRANSFER:
        return (
          <Button
            className={
              paymentOption === 'NEFT' ? 'active payment-btn' : 'payment-btn'
            }
            onClick={() => {
              setPaymentOption('NEFT');
              setUpiOption('');
            }}
          >
            <img
              className={'payment-icon'}
              alt="bank"
              src={bank}
              loading="lazy"
            />
          </Button>
        );

      case AvailablePaymentMethods.UPI:
        return (
          <Button
            className={
              UpiOption === 'UPI' ? 'active payment-btn' : 'payment-btn'
            }
            onClick={() => {
              setUpiOption('UPI');
              setPaymentOption('GPAY');
            }}
          >
            <img
              className={'payment-icon'}
              alt="bank"
              src={upiImg}
              loading="lazy"
            />
          </Button>
        );

      default:
        return null;
    }
  };

  return (
    <TabPanel value={tabValue} index={index} className="payment-options">
      <div className="payment-option-title">Choose Payment Option</div>
      {currentPaymentMethods &&
        currentPaymentMethods.length > 0 &&
        currentPaymentMethods.map((paymentMethod) =>
          renderPaymentMethodTab(paymentMethod)
        )}

      <div>
        {UpiOption ? (
          <>
            <Button
              className={
                paymentOption === 'GPAY' ? 'active payment-btn' : 'payment-btn'
              }
              onClick={() => setPaymentOption('GPAY')}
            >
              <img
                className={'payment-icon'}
                alt="gpay"
                src={gpay}
                loading="lazy"
              />
            </Button>
            <Button
              className={
                paymentOption === 'PHONEPE'
                  ? 'active payment-btn'
                  : 'payment-btn'
              }
              onClick={() => setPaymentOption('PHONEPE')}
            >
              <img
                className={'payment-icon'}
                alt="phonepay"
                src={phonePe}
                loading="lazy"
              />
            </Button>
            <Button
              className={
                paymentOption === 'PAYTM_WALLET'
                  ? 'active payment-btn'
                  : 'payment-btn'
              }
              onClick={() => setPaymentOption('PAYTM_WALLET')}
            >
              <img
                className={'payment-icon'}
                alt="paytm"
                src={paytm}
                loading="lazy"
                height={30}
              />
            </Button>
          </>
        ) : null}
        {accountDetails?.length > 0 ? (
          <>
            <div className="payment-form-divider"></div>

            <div className="payment-option-title">
              Choose Beneficiary Account
            </div>
          </>
        ) : null}
        <div className="account-details-ctn">
          <Tabs
            value={1}
            variant="scrollable"
            scrollButtons="off"
            className="actions-list"
          >
            <>
              {accountDetails?.map((acc) => (
                <>
                  <>
                    <div className="account-btn-ctn">
                      <Button
                        className={
                          acc?.id?.toString() === selectedAccountId
                            ? 'active account-detail-withdraw'
                            : 'account-detail-withdraw'
                        }
                        onClick={() =>
                          setSelectedAccountId(acc?.id?.toString())
                        }
                      >
                        <div className="account-name">
                          {acc?.paymentMethodDetails?.accountHolderName}
                        </div>
                        <div className="account-number">
                          {acc?.paymentMethodDetails?.accountNumber}
                        </div>
                        <div className="account-number">
                          {acc?.paymentMethodDetails?.upiId}
                        </div>
                        <div className="account-number">
                          {acc?.paymentMethodDetails?.phoneNumber}
                        </div>
                        <div className="account-number">
                          {acc?.paymentMethodDetails?.bankName}
                          {acc?.paymentMethodDetails?.bankName
                            ? ','
                            : null}{' '}
                          {acc?.paymentMethodDetails?.branchName}
                        </div>
                        {paymentOption === 'NEFT' && (
                          <div className="account-ifsc">
                            IFSC: {acc?.paymentMethodDetails?.ifscCode}
                          </div>
                        )}
                      </Button>
                      <div className="delete-btn-ctn">
                        <Button
                          className="method-delete-btn"
                          onClick={() => {
                            setShowDeleteModal(true);
                            setDeleteId(acc?.id);
                          }}
                        >
                          <DeleteForeverOutlined />
                        </Button>
                      </div>
                    </div>
                  </>
                </>
              ))}
            </>
          </Tabs>
          {/* {accountDetails?.length > 0 ? (
  <> */}

          {paymentOption ? (
            <Button
              title="Add Account"
              onClick={() => {
                setAddAccount(true);
              }}
              className="add-btn "
            >
              <div className="add-account ">
                <Add />{' '}
              </div>
            </Button>
          ) : null}

          {/* </> */}
          {/* ) : null} */}
        </div>
      </div>
      {selectedAccountId ? (
        <>
          <div className="withdraw-form-divider"></div>

          <form
            className="account-inputs"
            onSubmit={(e) => {
                submitPayment(e);
            }}
          >
            <div className="payment-option-title">Enter Payment Details</div>
            <div className="account-input">
              <div className="account-label">Enter Amount</div>
              <NumberFormat
                required
                className="acc-input"
                placeholder="Enter Withdraw Amount"
                value={withdrawAmount}
                decimalSeparator={false}
                onChange={(e) => setWithdrawAmount(e.target.value)}
              />
            </div>
            <div className="account-input">
              <div className="account-label">Enter Notes</div>
              <TextField
                required
                placeholder="Enter Notes"
                className="acc-input"
                value={withdrawNotes}
                onChange={(e) => setWithdrawNotes(e.target.value)}
              />
            </div>

            <Button
              className="submit-payment-btn"
              type="submit"
              disabled={loading ? true : false}
              endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
            >
              Submit
            </Button>
          </form>
        </>
      ) : null}

      {paymentOption === 'NEFT' && addAccount && (
        <form className="account-inputs" onSubmit={(e) => submitDetails(e)}>
          <div className="payment-option-title">Enter Details</div>
          <div className="account-input">
            <div className="account-label">Account Number</div>
            <NumberFormat
              required
              className="acc-input"
              placeholder="Enter Account Number"
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
              decimalSeparator={false}
            />
          </div>
          <div className="account-input">
            <div className="account-label">Account Holder Name</div>
            <TextField
              required
              placeholder="Account Holder Name"
              className="acc-input"
              value={holderName}
              onChange={(e) => setHolderName(e.target.value)}
            />
          </div>
          <div className="account-input">
            <div className="account-label">Bank Name</div>

            <TextField
              required
              placeholder="Bank Name"
              className="acc-input"
              value={bankName}
              onChange={(e) => setBankName(e.target.value)}
            />
          </div>
          <div className="account-input">
            <div className="account-label">Branch Name</div>

            <TextField
              required
              placeholder="Branch Name"
              className="acc-input"
              value={branchName}
              onChange={(e) => setBranchName(e.target.value)}
            />
          </div>
          <div className="account-input">
            <div className="account-label">IFSC Number</div>

            <TextField
              required
              placeholder="Ifsc code"
              className="acc-input"
              value={ifscCode}
              onChange={(e) => setIfscCode(e.target.value)}
            />
          </div>

          <Button
            className="submit-payment-btn"
            type="submit"
            endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
            disabled={loading ? true : false}
          >
            ADD
          </Button>
        </form>
      )}
      {paymentOption === 'PAYTM_WALLET' && addAccount && (
        <form className="account-inputs" onSubmit={(e) => submitDetails(e)}>
          <div className="payment-option-title">Enter Details</div>
          <div className="account-input">
            <div className="account-label">Phone Number</div>
            <NumberFormat
              required
              className="acc-input"
              placeholder="Enter Phone Number"
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
              decimalSeparator={false}
            />
          </div>
          <div className="account-input">
            <div className="account-label">Account Holder Name</div>
            <TextField
              required
              placeholder="Account Holder Name"
              className="acc-input"
              value={holderName}
              onChange={(e) => setHolderName(e.target.value)}
            />
          </div>
          <div className="account-input">
            <div className="account-label">Display Name</div>

            <TextField
              required
              placeholder="Display Name"
              className="acc-input"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
            />
          </div>

          <Button
            className="submit-payment-btn"
            type="submit"
            endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
            disabled={loading ? true : false}
          >
            ADD
          </Button>
        </form>
      )}

      {(paymentOption === 'GPAY' || paymentOption === 'PHONEPE') &&
        addAccount && (
          <>
            <div className="withdraw-form-divider"></div>
            <form className="account-inputs" onSubmit={(e) => submitDetails(e)}>
              <div className="payment-option-title">Enter UPI Details</div>
              <div className="account-input">
                <div className="account-label">Enter UPI ID</div>

                <TextField
                  required
                  className="acc-input"
                  placeholder="UPI ID"
                  value={accountNumber}
                  onChange={(e) => setAccountNumber(e.target.value)}
                />
              </div>
              <div className="account-input">
                <div className="account-label">Account Holder Name</div>

                <TextField
                  required
                  placeholder="Account Holder Name"
                  className="acc-input"
                  value={holderName}
                  onChange={(e) => setHolderName(e.target.value)}
                />
              </div>
              <div className="account-input">
                <div className="account-label">Display Name</div>

                <TextField
                  required
                  placeholder="Display Name"
                  className="acc-input"
                  value={displayName}
                  onChange={(e) => setDisplayName(e.target.value)}
                />
              </div>

              <Button
                className="submit-payment-btn"
                type="submit"
                endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
                disabled={loading ? true : false}
              >
                ADD
              </Button>
            </form>
          </>
        )}
    </TabPanel>
  );
};

export default Pgman;
